/**
 * Preload czyta asset-manifest.json; brak pliku WP13 → placeholdery.
 * WP0 zamraża ten loader — WP13 dostarcza tylko dane.
 */

export type AssetEntry = {
  id: string;
  group: 'boot' | 'world' | 'minigames' | 'pool' | 'stable' | 'ui' | 'audio';
  type: 'image' | 'atlas' | 'audio' | 'json';
  url?: string;
  placeholder?: string;
};

export type AssetManifest = {
  version: number;
  assets: AssetEntry[];
};

export async function loadAssetManifest(): Promise<AssetManifest> {
  try {
    const res = await fetch('/asset-manifest.json');
    if (res.ok) {
      return (await res.json()) as AssetManifest;
    }
  } catch {
    /* fallthrough */
  }
  try {
    const res = await fetch('/assets.manifest.json');
    if (res.ok) return (await res.json()) as AssetManifest;
  } catch {
    /* fallthrough */
  }
  return { version: 0, assets: [] };
}

export function resolveAssetUrl(entry: AssetEntry): string {
  if (entry.url) return entry.url;
  return entry.placeholder ?? `/assets/placeholder/${entry.id}.png`;
}
